import type { Substance } from './types';

export function makeSpectrum(peaks: [number, number, number][], n: number): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i <= n; i++) {
    const x = 200 + (i / n) * 1800;
    let y = 0.02 + 0.012 * Math.sin(i * 0.7) * Math.random() * 0.4;
    peaks.forEach(([c, h, w]) => {
      y += h * Math.exp(-((x - c) ** 2) / (2 * w * w));
    });
    pts.push([x, y]);
  }
  return pts;
}

export const substances: Substance[] = [
  {
    id: "meth",
    name: "Метамфетамин",
    nameEn: "Methamphetamine",
    cas: "537-46-2",
    formula: "C10H15N",
    appearanceKo: "백색 결정성 분말",
    appearanceMn: "Цагаан талст нунтаг",
    aliasKo: "아이스, крис, муур",
    aliasMn: "Айс, крис, муур",
    refCount: 14,
    fieldCount: 132,
    caseCount: 48,
    peaks: [[1001, 0.95, 14], [1207, 0.42, 18], [1585, 0.36, 16], [1030, 0.30, 12], [830, 0.22, 16], [621, 0.18, 10], [1450, 0.15, 22]],
    refs: [
      { code: "СЛ-МЕТ-001", equip: "Raman (785 nm)", date: "2025-11-02", status: "verified" },
      { code: "СЛ-МЕТ-002", equip: "Raman (1064 nm)", date: "2025-12-14", status: "verified" },
      { code: "СЛ-МЕТ-003", equip: "FTIR", date: "2026-01-21", status: "verified" },
      { code: "СЛ-МЕТ-004", equip: "GC-MS", date: "2026-02-08", status: "unverified" },
    ],
  },
  {
    id: "heroin",
    name: "Героин",
    nameEn: "Heroin",
    cas: "561-27-3",
    formula: "C21H23NO5",
    appearanceKo: "갈색 분말",
    appearanceMn: "Бор өнгийн нунтаг",
    aliasKo: "цагаан, гэр",
    aliasMn: "Цагаан, гэр",
    refCount: 9,
    fieldCount: 41,
    caseCount: 17,
    peaks: [[1632, 0.85, 16], [1245, 0.55, 18], [990, 0.40, 14], [1370, 0.32, 20], [755, 0.25, 12], [530, 0.18, 14]],
    refs: [
      { code: "СЛ-ГЕР-001", equip: "Raman (785 nm)", date: "2025-10-19", status: "verified" },
      { code: "СЛ-ГЕР-002", equip: "FTIR", date: "2026-01-05", status: "verified" },
    ],
  },
  {
    id: "mdma",
    name: "MDMA",
    nameEn: "3,4-MDMA",
    cas: "42542-10-9",
    formula: "C11H15NO2",
    appearanceKo: "정제 (각인 다양)",
    appearanceMn: "Шахмал (янз бүрийн хээтэй)",
    aliasKo: "экстази, э",
    aliasMn: "Экстази, Э",
    refCount: 11,
    fieldCount: 67,
    caseCount: 23,
    peaks: [[810, 0.90, 14], [1248, 0.48, 16], [1442, 0.38, 18], [1612, 0.30, 14], [716, 0.26, 10], [1050, 0.20, 16]],
    refs: [
      { code: "СЛ-МДМ-001", equip: "Raman (785 nm)", date: "2025-09-28", status: "verified" },
      { code: "СЛ-МДМ-002", equip: "Raman (1064 nm)", date: "2025-11-30", status: "verified" },
      { code: "СЛ-МДМ-003", equip: "GC-MS", date: "2026-02-19", status: "unverified" },
    ],
  },
  {
    id: "cannabis",
    name: "Каннабис",
    nameEn: "Cannabis (THC)",
    cas: "1972-08-3",
    formula: "C21H30O2",
    appearanceKo: "건조 식물체",
    appearanceMn: "Хатаасан ургамал",
    aliasKo: "новч, өвс",
    aliasMn: "Новч, өвс",
    refCount: 7,
    fieldCount: 88,
    caseCount: 31,
    peaks: [[1601, 0.80, 18], [1295, 0.45, 20], [1440, 0.40, 16], [1163, 0.28, 14], [740, 0.20, 12]],
    refs: [
      { code: "СЛ-КАН-001", equip: "Raman (785 nm)", date: "2025-12-03", status: "verified" },
      { code: "СЛ-КАН-002", equip: "FTIR", date: "2026-01-17", status: "verified" },
    ],
  },
  {
    id: "ketamine",
    name: "Кетамин",
    nameEn: "Ketamine",
    cas: "6740-88-1",
    formula: "C13H16ClNO",
    appearanceKo: "백색 분말 또는 액상",
    appearanceMn: "Цагаан нунтаг эсвэл шингэн",
    aliasKo: "К, кей",
    aliasMn: "К, кей",
    refCount: 6,
    fieldCount: 25,
    caseCount: 9,
    peaks: [[1715, 0.75, 16], [1043, 0.50, 14], [1230, 0.35, 18], [890, 0.28, 12], [680, 0.22, 14], [1590, 0.18, 16]],
    refs: [
      { code: "СЛ-КЕТ-001", equip: "Raman (785 nm)", date: "2026-01-12", status: "verified" },
      { code: "СЛ-КЕТ-002", equip: "GC-MS", date: "2026-03-01", status: "unverified" },
    ],
  },
];
